<life-di-nav></life-di-nav>
<lifedi-breadcrumb *ngIf="!isEdit" lastPath="สร้าง workshop"></lifedi-breadcrumb>
<lifedi-breadcrumb *ngIf="isEdit" lastPath="แก้ไข workshop"></lifedi-breadcrumb>

<div class="container" *ngIf="!isEdit">
  <h1 class="lifedi-color text-center mb-5">
    ระบบกิจกรรม
    <!-- สินค้าและกิจกรรม -->
  </h1>

  <!-- not edit -->
  <form [formGroup]="workshopForm">
    <!-- {{workshopForm.value|json}} -->
    <div class="row">
      <div class="col-md-6 col-12">

        <div class="form-group row">
          <label for="workshopStatus" class="col-4 col-form-label">สถานะ<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <mat-checkbox id="workshopStatus" color="primary" class="form-control-plaintext"
              formControlName="statusPublic">เผยแพร่
            </mat-checkbox>
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopName" class="col-4 col-form-label">ชื่อ Workshop<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="text" class="form-control" id="workshopName" formControlName="workshopName" autocomplete="off">
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopCover" class="col-4 col-form-label">รูปภาพปก<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="workshopCover" accept=".png, .jpg, .jpeg"
                (change)="onCoverSelected($event, workshopForm)">
              <label *ngIf="!workshopCover" class="custom-file-label" for="workshopCover">Choose file</label>
              <label *ngIf="workshopCover" class="custom-file-label" for="workshopCover">{{ workshopCover }}</label>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopDoc" class="col-4 col-form-label">
            อัปโหลดเอกสาร
            <small class="text-danger">(ถ้ามี)</small>
          </label>
          <div class="col-8">
            <nz-upload
              nzAccept=".pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excelapplication/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              [nzCustomRequest]="successRequest" [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload" [nzLimit]="5"
              [nzShowUploadList]="{ showRemoveIcon: true ,showDownloadIcon: false }"
              (nzChange)="handleChange($event, workshopForm)">
              <button nz-button style="width: 100%;"><i nz-icon nzType="upload"></i>Upload</button>
            </nz-upload>
          </div>
        </div>

        <div class="form-group row">
          <label for="joinType" class="col-4 col-form-label">ประเภทเข้าร่วม<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <select class="custom-select form-control" style="display: inline;" formControlName="joinType">
              <option *ngFor="let j of joinType" [id]="j.type" [value]="j.type">{{ j.type }}</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopPlace"
            class="col-4 col-form-label">สถานที่จัดงาน/ลิงก์<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="text" class="form-control" id="workshopPlace" formControlName="workshopPlace"
              autocomplete="off">
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopDateTime" class="col-4 col-form-label">
            วัน เวลาที่จัด workshop<lifedi-require></lifedi-require>
            <!-- <small class="text-danger">* วันที่จัด workshop ต้องเป็นวันเดียวกัน</small> -->
          </label>
          <div class="col-8">
            <div *ngFor="let w of workshopForm.get('workshopDateTime')['controls']; let i = index"
              formArrayName="workshopDateTime" class="container mb-3">
              <div class="row" [formGroupName]="i">
                <input id="workshopDateTime" class="form-control col-10" formControlName="dateTime"
                  date-format="dd-MM-yyyy HH:mm:ss" [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker"
                  [owlDateTime]="dtPicker" [rangeSeparator]="'-'" dateFormat="dd-MM-yyyy" autocomplete="off">

                <owl-date-time #dtPicker></owl-date-time>
                <div class="offset-1"></div>
                <button mat-mini-fab *ngIf="i >= 1" class="img col-1" (click)="removeGroup(i, false)"
                  [style.backgroundImage]="'url(\'../../../../../assets/close.png\')'"></button>
                <small class="text-danger">* วันจัด workshop แต่ละครั้งต้องเป็นวันเดียวกัน</small>
              </div>
            </div>

            <button mat-mini-fab class="img" (click)="addGroup(false)"
              [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
            </button>
          </div>
        </div>

        <div class="form-group row">
          <label for="type" class="col-4 col-form-label">ศูนย์ย่อย</label>
          <div class="col-8">
            <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" #tag [(ngModel)]="LN_TAG"
              [ngModelOptions]="{standalone: true}" [change]="patchLearning(tag, workshopForm)" style="width: 100%"
              [compareWith]="compareLNFn">
              <nz-option *ngFor="let center of allLearningCenter" [nzLabel]="center.CENTER_NAME"
                [nzValue]="center"></nz-option>
            </nz-select>
          </div>
        </div>

      </div>
      <div class="col-md-6 col-12">
        <div class="form-group row">
          <label for="workshopCoach" class="col-4 col-form-label">วิทยากร<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="text" class="form-control" id="workshopCoach" formControlName="workshopCoach"
              autocomplete="off">
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopCoachPic" class="col-4 col-form-label">รูปวิทยากร<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="workshopCoachPic" accept=".png, .jpg, .jpeg"
                (change)="onCoachPicSelected($event, workshopForm)">
              <label class="custom-file-label" for="workshopCoachPic">Choose file</label>

              <label *ngIf="!workshopCoachPic" class="custom-file-label" for="workshopCoachPic">Choose file</label>
              <label *ngIf="workshopCoachPic" class="custom-file-label" for="workshopCoachPic">
                {{ workshopCoachPic }}
              </label>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopCoachAssit" class="col-4 col-form-label">วิทยากรร่วม</label>
          <div class="col-8">
            <nz-select nzMode="tags" [nzTokenSeparators]="[',']" style="width: 100%;" #value
              [change]="patch(value, false)">
              <nz-option *ngFor="let option of workshopCoachAssit" [nzLabel]="option.value" [nzValue]="option.value">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopPrice" class="col-4 col-form-label">ราคา<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="number" class="form-control" id="workshopPrice" min="0" step="100"
              formControlName="workshopPrice" />
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopQuantity"
            class="col-4 col-form-label">จำนวนผู้สมัคร<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="number" class="form-control" id="workshopQuantity" formControlName="workshopQuantity"
              autocomplete="off">
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopPhoneNO"
            class="col-4 col-form-label">เบอร์โทรศัพท์<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="text" class="form-control" id="workshopPhoneNO" formControlName="workshopPhoneNO"
              MaxLength="10" autocomplete="off">
            <div *ngIf="f.workshopPhoneNO.touched && f.workshopPhoneNO.invalid">
              <div *ngIf="f.workshopPhoneNO.errors.required" class="text-danger">กรุณาใส่เบอร์โทรศัพท์</div>
              <div *ngIf="f.workshopPhoneNO.errors.pattern" class="text-danger">กรุณาใส่เบอร์โทรศัพท์จำนวน 9-10 หลัก
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label for="acccount" class="col-4 col-form-label">
            บัญชี<lifedi-require></lifedi-require>
          </label>
          <div class="col-8">
            <select class="custom-select form-control" style="width: 100%;" formControlName="accountId">
              <option *ngFor="let s of account" [value]="s.ACCOUNTING_ID">
                บัญชี{{ s.ACCOUNTING_NAME }} ({{ s.ACCOUNTING_ID }})
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <label for="_content"
        class="col-12 col-form-label text-center">รายละเอียด<lifedi-require></lifedi-require></label>
      <div class="col-12">
        <angular-editor id="_content" formControlName="workshopDetail" [config]="editorConfig"></angular-editor>
      </div>
    </div>
  </form>
  <div style="margin: 15px auto; padding-bottom: 10px; width: fit-content;">
    <lifedi-btn lable="สร้าง" *ngIf="workshopForm.valid" (click)="createWorkshop(workshopForm.value)"
      customStyle=" color:white; background-color: #414A6B; width: 300px;">
    </lifedi-btn>
    <lifedi-btn lable="สร้าง" *ngIf="!workshopForm.valid" [disabled]="!workshopForm.valid" customStyle="width: 300px;">
    </lifedi-btn>
  </div>
</div>



<div class="container" *ngIf="isEdit && workshopData">
  <button mat-mini-fab color="warn" class="float-right btn-delete"
    (click)="delete(workshopData.WORKSHOP_ID, workshopData.WORKSHOP_NAME)">
    <img src="../../../../assets/delete.png" style="width: 22px; margin-left: 4px; margin-top: -4px;">
  </button>
</div>


<!-- Edit -->
<div class="container" *ngIf="isEdit && workshopData">
  <h1 class="lifedi-color text-center mb-5">แก้ไขกิจกรรม</h1>

  <form [formGroup]="workshopEditForm">
    <!-- {{workshopData|json}} -->
    <div class="row">
      <div class="col-md-6 col-12">

        <div class="form-group row">
          <label for="workshopStatus" class="col-4 col-form-label">สถานะ<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <mat-checkbox id="workshopStatus" color="primary" class="form-control-plaintext"
              formControlName="statusPublic" [(ngModel)]="status">เผยแพร่
            </mat-checkbox>
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopName" class="col-4 col-form-label">ชื่อ Workshop<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="text" class="form-control" id="workshopName" formControlName="workshopName" autocomplete="off"
              [(ngModel)]="workshopData.WORKSHOP_NAME">
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopCover" class="col-4 col-form-label">รูปภาพปก<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="workshopCover" accept=".png, .jpg, .jpeg"
                (change)="onCoverSelected($event, workshopEditForm)">
              <label *ngIf="!workshopCover" class="custom-file-label" for="workshopCover">Choose file</label>
              <label *ngIf="workshopCover" class="custom-file-label" for="workshopCover">{{ workshopCover }}</label>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopDoc" class="col-4 col-form-label">
            อัปโหลดเอกสาร
            <small class="text-danger">(ถ้ามี)</small>
          </label>
          <div class="col-8">
            <nz-upload
              nzAccept=".pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excelapplication/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              [nzCustomRequest]="successRequest" [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload" [nzLimit]="5"
              [nzShowUploadList]="{ showRemoveIcon: true ,showDownloadIcon: false }"
              (nzChange)="handleChange($event, workshopEditForm)">
              <button nz-button style="width: 100%;"><i nz-icon nzType="upload"></i>Upload</button>
            </nz-upload>
          </div>
        </div>

        <div class="form-group row">
          <label for="joinType" class="col-4 col-form-label">ประเภทเข้าร่วม<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <select class="custom-select form-control" [(ngModel)]="workshopData.JOIN_TYPE" style="display: inline;"
              formControlName="joinType">
              <option *ngFor="let j of joinType" [id]="j.type" [value]="j.type">{{ j.type }}</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopPlace"
            class="col-4 col-form-label">สถานที่จัดงาน/ลิงก์<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="text" class="form-control" id="workshopPlace" formControlName="workshopPlace"
              autocomplete="off" [(ngModel)]="workshopData.WORKSHOP_PLACE">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-4 col-form-label">
            วัน เวลาที่จัด workshop<lifedi-require></lifedi-require>
          </label>
          <div class="col-8">
            <div *ngFor="let w of workshopEditForm.get('workshopDateTime')['controls']; let i = index"
              formArrayName="workshopDateTime" class="container mb-3">
              <div class="row" [formGroupName]="i">
                <input class="form-control col-10" formControlName="dateTime" style="width: 98%;"
                  date-format="dd-MM-yyyy HH:mm:ss" [(ngModel)]="dateTimeRange[i]" [selectMode]="'range'"
                  [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" [rangeSeparator]="'-'"
                  dateFormat="dd-MM-yyyy" autocomplete="off">

                <owl-date-time #dtPicker></owl-date-time>
                <div class="offset-1"></div>
                <button mat-mini-fab *ngIf="i >= 1" class="img col-1" style="max-width: 25px !important;"
                  (click)="removeGroup(i, true)"
                  [style.backgroundImage]="'url(\'../../../../../assets/close.png\')'"></button>
                <small class="text-danger">* วันจัด workshop แต่ละครั้งต้องเป็นวันเดียวกัน</small>
              </div>
            </div>

            <button mat-mini-fab class="img" (click)="addGroup(true)"
              [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
            </button>
          </div>
        </div>

        <div class="form-group row">
          <label for="type" class="col-4 col-form-label">ศูนย์ย่อย</label>
          <div class="col-8">
            <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" #tag [(ngModel)]="LN_TAG"
              [ngModelOptions]="{standalone: true}" [change]="patchLearning(tag, workshopEditForm)" style="width: 100%"
              [compareWith]="compareLNFn">
              <nz-option *ngFor="let center of allLearningCenter" [nzLabel]="center.CENTER_NAME"
                [nzValue]="center"></nz-option>
            </nz-select>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12">
        <div class="form-group row">
          <label for="workshopCoach" class="col-4 col-form-label">วิทยากร<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="text" class="form-control" id="workshopCoach" formControlName="workshopCoach"
              autocomplete="off" [(ngModel)]="workshopData.WORKSHOP_COACH">
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopCoachPic" class="col-4 col-form-label">รูปวิทยากร<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="workshopCoachPic" accept=".png, .jpg, .jpeg"
                (change)="onCoachPicSelected($event, workshopEditForm)">

              <label *ngIf="!workshopCoachPic" class="custom-file-label" for="workshopCoachPic">Choose file</label>
              <label *ngIf="workshopCoachPic" class="custom-file-label" for="workshopCoachPic">
                {{ workshopCoachPic }}
              </label>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopCoachAssit" class="col-4 col-form-label">วิทยากรร่วม</label>
          <div class="col-8">
            <nz-select nzMode="tags" [(ngModel)]="workshopData.WORKSHOP_COACH_ASSIT" [nzTokenSeparators]="[',']"
              [ngModelOptions]="{standalone: true}" style="width: 100%;" #value [change]="patch(value, true)">
            </nz-select>
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopPrice" class="col-4 col-form-label">ราคา<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="number" class="form-control" id="workshopPrice" min="0" step="100"
              formControlName="workshopPrice" [(ngModel)]="workshopData.WORKSHOP_PRICE" />
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopQuantity"
            class="col-4 col-form-label">จำนวนผู้สมัคร<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="number" min="1" class="form-control" id="workshopQuantity" formControlName="workshopQuantity"
              autocomplete="off" [(ngModel)]="workshopData.WORKSHOP_QTY_LEARNERS">
          </div>
        </div>

        <div class="form-group row">
          <label for="workshopPhoneNO"
            class="col-4 col-form-label">เบอร์โทรศัพท์<lifedi-require></lifedi-require></label>
          <div class="col-8">
            <input type="text" class="form-control" id="workshopPhoneNO" formControlName="workshopPhoneNO"
              MaxLength="10" autocomplete="off" [(ngModel)]="workshopData.WORKSHOP_PHONENUM">
            <div *ngIf="fe.workshopPhoneNO.touched && fe.workshopPhoneNO.invalid">
              <div *ngIf="fe.workshopPhoneNO.errors.required" class="text-danger">กรุณาใส่เบอร์โทรศัพท์</div>
              <div *ngIf="fe.workshopPhoneNO.errors.pattern" class="text-danger">กรุณาใส่เบอร์โทรศัพท์จำนวน 9-10 หลัก
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label for="coursePic" class="col-4 col-form-label">
            บัญชี<lifedi-require></lifedi-require>
          </label>
          <div class="col-8">
            <select class="custom-select form-control" style="width: 100%;" formControlName="accountId"
              [(ngModel)]="workshopData.ACCOUNTING_ID">
              <option *ngFor="let s of account" [value]="s.ACCOUNTING_ID">
                บัญชี{{ s.ACCOUNTING_NAME }} ({{ s.ACCOUNTING_ID }})
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <label for="_content"
        class="col-12 col-form-label text-center">รายละเอียด<lifedi-require></lifedi-require></label>
      <div class="col-12">
        <angular-editor id="_content" formControlName="workshopDetail" [config]="editorConfig"
          [(ngModel)]="workshopData.WORKSHOP_DETAIL"></angular-editor>
      </div>
    </div>
  </form>

  <div style="margin: 15px auto; padding-bottom: 10px; width: fit-content;">
    <lifedi-btn lable="บันทึก" *ngIf="workshopEditForm.valid" (click)="editWorkshop(workshopEditForm.value)"
      customStyle=" color:white; background-color: #414A6B; width: 300px;">
    </lifedi-btn>
    <lifedi-btn lable="บันทึก" *ngIf="!workshopEditForm.valid" [disabled]="!workshopEditForm.valid"
      customStyle="width: 300px;">
    </lifedi-btn>
  </div>
</div>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>